<template>
	<div
		class="row p-3"
		:class="$style.row"
	>
		<div class="col-7 d-none d-xl-block text-center">
			<img
				:class="$style.astronaut"
				alt="GestiOS Data Software"
				src="@/system/assets/images/public/404.png"
			>
		</div>

		<div
			class="
				col-10 offset-1
				col-md-8 offset-md-2
				col-xl-5 offset-xl-0
				text-center text-xl-right
			"
		>
			<img
				:class="$style.astronaut"
				class="d-block d-xl-none mx-auto img-fluid mb-4"
				alt="GestiOS Data Software"
				src="@/system/assets/images/public/404.png"
			>

			<h1 class="mb-3 text-white font-size-40 text-uppercase">
				<span
					class="
						d-block d-sm-inline-block
						animate__animated animate__shakeX animate__delay-1s
						font-size-50
					"
				>💣</span> Página no encontrada
			</h1>

			<div class="text-gray-4 mb-3 font-size-21 text-normal text-sm-justify">
				Navegas hacia lo desconocido. Esta página está obsoleta, eliminada o no existe.
				Vuelve al Inicio.
			</div>

			<a-button
				type="primary"
				size="large"
				@click="$router.replace('/')"
			>
				Inicio
			</a-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Error404'
};
</script>

<style lang="scss" module>

.row{
	background: url('../../../assets/images/public/404-bg.png') no-repeat left top;
	background-color: $dark;
	background-size: auto 100%;
	height: 100vh;
	align-items: center;
	display: flex;
}

.astronaut {
	transform: translatey(0px);
	animation: float 6s ease-in-out infinite;
	max-width: 75%;
}

@keyframes float {
	0% {
		transform: translatey(0px);
	}
	50% {
		transform: translatey(-20px);
	}
	100% {
		transform: translatey(0px);
	}
}

@media (max-width: 1200px) {
	.astronaut {
		max-width: 300px;
	}
}

@media (max-width: 700px) {
	.astronaut {
		max-width: 200px;
	}
}

</style>
